import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ArticleCommentsTrigger } from "~/components/article/article-comments-trigger";
import type { articleActionWidgetArticle$key } from "~/queries/__generated__/articleActionWidgetArticle.graphql";

import { Container, StyledContentBookmark } from "./styles";

type Props = {
  className?: string;
  reference: articleActionWidgetArticle$key;
};
export const ArticleActionWidget: FunctionComponent<Props> = ({
  className,
  reference: reference_,
}) => {
  const article = useFragment(
    graphql`
      fragment articleActionWidgetArticle on Article {
        ...articleCommentsTriggerArticle
        entityId
        urlAlias
      }
    `,
    reference_,
  );

  return (
    <Container className={className}>
      <ArticleCommentsTrigger location="Article Side" reference={article} variant="widget" />
      <StyledContentBookmark
        entityId={article.entityId}
        location="side"
        urlAlias={article.urlAlias}
      />
    </Container>
  );
};
ArticleActionWidget.displayName = "ArticleActionWidget";
